<p-confirmDialog key="addhallpass" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Grid-->
<div class="MainGrid">
	<label>Create Hall Pass for:</label>
	<label>{{ PersonName }}</label>

	<label>Student ID:</label>
	<label>{{ DesignatorID }}</label>

	<label *ngIf="IsNotQuick() == false">Created at Facility Location:</label>
	<!-- <label>{{SelectedFacilityLocationID}}</label> -->
	<label *ngIf="IsNotQuick() == false">{{ FromLocationDesc }}</label>

	<label>Hall Pass Reason:</label>
	<select class="form-control" name="SelectedHallPassReason" [(ngModel)]="SelectedHallPassReason" [disabled]="IsLoading() == true">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstHallPassReason" [ngValue]="o">
			{{ o.HallpassReasonDesc }}
		</option>
	</select>

	<!--Optional Class Attendance Excuse-->
	<label *ngIf="IsNotQuick()">Class Attendance Excuse:</label>
	<select
		*ngIf="IsNotQuick()"
		class="form-control"
		name="SelectedExcuse"
		[(ngModel)]="SelectedExcuse"
		[disabled]="IsLoading() == true"
		[style.color]="SelectedExcuse != null && SelectedExcuse.IsCountAsPresent == false ? 'Red' : 'Black'"
	>
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstExcuse" [ngValue]="o" [style.color]="o.IsCountAsPresent == true ? 'Black' : 'Red'">
			{{ o.ClassAttendanceExcuseDesc }}
		</option>
	</select>

	<!--Optional From Location Desc-->
	<label *ngIf="IsNotQuick()">From Location:</label>
	<label *ngIf="IsNotQuick()">{{ FromLocationDesc }}</label>

	<!--Optional To Facilty Location-->
	<label *ngIf="IsNotQuick()">To Location:</label>
	<select *ngIf="IsNotQuick()" class="form-control" name="SelectedLocation" [(ngModel)]="SelectedLocation" [disabled]="IsLoading() == true">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstLocation" [ngValue]="o">
			{{ o.FacilityLocationName }}
		</option>
	</select>

	<!--Optional Pass Duration-->
	<label *ngIf="IsNotQuick()">Pass Duration (Minutes):</label>
	<input *ngIf="IsNotQuick()" class="form-control" type="number" min="0" [(ngModel)]="PassDurationMinutes" [disabled]="IsLoading() == true" />

	<label>Comments:</label>
	<textarea [(ngModel)]="Comments" class="TextArea" rows="5" [disabled]="IsLoading() == true"></textarea>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" [disabled]="IsLoading() == true" (click)="onAdd()">Add</button>
	<button class="btn btn-warning" [disabled]="Processing == true" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="form-group Buttons">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
